import { useEffect } from 'react';

/**
 * **창이 떠 있는 동안 뒤 화면이 스크롤되지 않게 잠그고, 닫으면 보던 자리로 돌려놓는다.**
 *
 * 폰에서 뒤 화면을 잠그려고 `body` 를 `position: fixed` 로 박으면 페이지가 맨 위로 튄다 — 고정된 body 는 스크롤
 * 위치를 모른다. 예전에는 그 자리를 기억하지 않아서, 전투기록 목록에서 길드원 폴드를 펼쳐 기록 창을 보고 닫으면
 * **목록 맨 위로 올라가 있었다**(사용자 제보 2026-10-10). 그래서 잠글 때 `top: -스크롤` 로 화면을 그 자리에 붙들고,
 * 풀 때 그만큼 다시 스크롤한다.
 *
 * `locked` 가 바뀔 때만 돈다 — 창이 떠 있는 채로 다른 기록으로 바뀌어도 다시 재지 않는다(그때 재면 0 이다).
 */
export function useBodyScrollLock(locked: boolean): void {
    useEffect(() => {
        if (!locked) return;
        const y = window.scrollY;
        const body = document.body.style;
        const html = document.documentElement.style;
        const prev = {
            position: body.position, top: body.top, left: body.left, right: body.right,
            width: body.width, overflow: body.overflow, htmlOverflow: html.overflow
        };

        body.position = 'fixed';
        body.top = `-${y}px`;
        body.left = '0';
        body.right = '0';
        body.width = '100%';
        body.overflow = 'hidden';
        html.overflow = 'hidden';

        // 터치로 뒤 화면이 끌려 다니지 않게 (예전과 같다)
        const preventScroll = (e: TouchEvent) => { e.preventDefault(); };
        document.addEventListener('touchmove', preventScroll, { passive: false });

        return () => {
            document.removeEventListener('touchmove', preventScroll);
            body.position = prev.position;
            body.top = prev.top;
            body.left = prev.left;
            body.right = prev.right;
            body.width = prev.width;
            body.overflow = prev.overflow;
            html.overflow = prev.htmlOverflow;
            // 부드러운 스크롤이 켜져 있어도 단번에 — 닫는 순간 화면이 미끄러지면 안 된다
            window.scrollTo({ top: y, left: 0, behavior: 'instant' as ScrollBehavior });
        };
    }, [locked]);
}
